export default {
  displayMap: true,
  panelView: 'grid',
  mapDetailCommunity: false,
  mapDetailQuickMoveIn: false,
  zoomToLocation: false,
};
